module.exports = __webpack_public_path__ + "img/logo.db86174d.svg";